import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { io } from 'socket.io-client';
import { TdarrDupeStatus, TdarrResourceStats, TdarrServerClock } from './types';

const collectionEvents = [
  'syncAutomationsJSONDB',
  'syncFlowsJSONDB',
  'syncLibrarySettingsJSONDB',
  'syncSettingsGlobalJSONDB',
  'syncStatisticsJSONDB',
  'syncVariablesJSONDB'
];
const tableEvents = ['syncClientTables', 'syncLastQueueUpdateTime'];

export default function LiveUpdates() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const socket = io({ path: `${window.Sonarr.urlBase || ''}/socket.io`, transports: ['websocket'] });
    collectionEvents.forEach((eventName) => socket.on(eventName, () => queryClient.invalidateQueries({ queryKey: ['tdarr', 'collection'] })));
    tableEvents.forEach((eventName) => socket.on(eventName, () => queryClient.invalidateQueries({ queryKey: ['tdarr', 'client'] })));
    socket.on('syncNodes', () => queryClient.invalidateQueries({ queryKey: ['tdarr', 'nodes'] }));
    socket.on('syncResStats', (resources: TdarrResourceStats) => queryClient.setQueryData<TdarrResourceStats>(['tdarr', 'resources'], resources));
    socket.on('syncServerTime', (serverTime: number) => {
      const clock: TdarrServerClock = {
        value: serverTime + new Date().getTimezoneOffset() * 60 * 1000,
        syncedAt: Date.now()
      };
      queryClient.setQueryData<TdarrServerClock>(['tdarr', 'server-time'], clock);
    });
    socket.on('syncDupeManagerStatus', (status: TdarrDupeStatus) => {
      queryClient.setQueryData(['tdarr', 'dupe-status'], status);
      if (status.stage === 'done') queryClient.invalidateQueries({ queryKey: ['tdarr', 'client', 'dedupe'] });
    });
    return () => {
      socket.disconnect();
    };
  }, [queryClient]);

  return null;
}
